export const paymentCardInfo = {
	payment: "Pagamento",
	cashPayment: "À vista",
	installmentsPayment: "Parcelado",
};
